import * as yup from "yup";
import { useExtendedFormik } from "../../../../../../hooks/useExtendedFormik";
import { history } from "../../../../../../history";
import { SETTINGS_ROUTES } from "../../../../../../consts/routes";

const schema = yup.object({
  name: yup.string().trim().required(),
  title: yup.string().trim().required(),
  phrase: yup.string().trim().required(),
});

export const useForm = (initialValues, onSubmit) => {
  const { values, handleChange, handleBlur, getError, handleSubmit, dirty } =
    useExtendedFormik({
      enableReinitialize: true,
      initialValues: {
        name: initialValues?.name || "",
        title: initialValues?.title || "",
        phrase: initialValues?.phrase || "",
      },
      validationSchema: schema,
      onSubmit: (values, { resetForm }) => {
        return onSubmit(values).then(() => {
          resetForm();
          history.push(SETTINGS_ROUTES.smsSnippets.all());
        });
      },
    });

  return {
    submit: handleSubmit,
    dirty,
    name: {
      value: values.name,
      onChange: handleChange,
      onBlur: handleBlur,
      getError: () => getError("name"),
    },
    title: {
      value: values.title,
      onChange: handleChange,
      onBlur: handleBlur,
      getError: () => getError("title"),
    },
    phrase: {
      value: values.phrase,
      onChange: handleChange,
      onBlur: handleBlur,
      getError: () => getError("phrase"),
    },
  };
};
